import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import XLSX from "xlsx";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import { Dropdown } from "primereact/dropdown";
import {
    createAPIEndpointReports,
    EndpointReports,
} from "../../../Services/ReportsAll/GrnDataExcelService";
import { Calendar } from "primereact/calendar";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";

const NonInventoryReport = () => {
//   const currentDate = format(new Date(), "yyyy-MM-dd");
    // const date = subDays(new Date(), 7);
    // const sevenDays = format(date, "yyyy-MM-dd");
    // const [fromDate, setFromDate] = useState(sevenDays);
    // const [toDate, setToDate] = useState(currentDate);

    const date = subDays(new Date(), 7);
    // const sevenDays = format(date, "yyyy-MM-dd");
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());

    const [loadingExcel, setLoadingExcel] = useState(false);
    const [reportType, setReportType] = useState(null);
    const ReportTypes = [
        { label: "Inward Report", value: "IN" },
        { label: "Outward Report", value: "OUT" },
        { label: "Reconciliation Report", value: "REC" },
    ];

    const handleExportExcel = () => {
        if (reportType == null) {
            toast.error("Please select Report Type", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        const auth = storage.getLocal("user");
        setLoadingExcel(true);
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");

        let uniqueNo = `NonInventoryReport${reportType}${GetDateFormat()}`;
        createAPIEndpointReports()
            .get(
                `${EndpointReports.nonInvReport}?CompId=${auth.CompId}&strFromDateString=${fromDateRange}&strToDateString=${toDateRange}&report_type=${reportType}`
            )
            .then((val) => {
                if (val.data.length > 0) {
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(val.data);
                    XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
                    XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
                } else {
                    toast.warning("No data found between these dates", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                }
                setLoadingExcel(false);
            })
            .catch((err) => {
                toast.error(`${err.response.data}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            });
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <h3 className="py-2">Non Inventory Report</h3>
            <section className="sales-box">
                <form>
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-3 col-md-3 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => {
                                    setFromDate(e.target.value);
                                }}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                            />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                            />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                            <label className="form-label">Report Type</label>
                            <Dropdown
                                value={reportType}
                                options={ReportTypes}
                                onChange={(e) => setReportType(e.value)}
                                optionLabel="label"
                                placeholder="Select a Report type"
                            />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                            <div className="text-end">
                                {/* <button disabled={loadingExcel} type="button" title="Save As Excel" className="btn btn-primary" onClick={()=>{handleExportExcel(fromDate,toDate);}}>
                                    {loadingExcel ? "Loading..." : "Save As Excel"}
                                </button> */}
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        handleExportExcel();
                                    }}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Save as Excel"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaFileExport className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    );
};

export default NonInventoryReport;
